import type { JSX, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface Tab {
  value: string;
  label: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export function Tabs({ tabs, value, onValueChange, className }: TabsProps): JSX.Element {
  return (
    <div role="tablist" className={cn("flex flex-wrap border-b border-border", className)}>
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onValueChange(tab.value)}
            className={cn(
              "-mb-px whitespace-nowrap border-b-2 px-4 py-2 text-body-2 transition-colors",
              active
                ? "border-brand-extra-2-40 font-semibold text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
